<ng-container [formGroup]="parentFormGroup">
  <pg-radio-group
    [formControlName]="radioModel?.formControlName"
    [id]="radioModel?.id"
  >
    <pg-radio-button
      [fontFamily]="radioModel?.fontFamily"
      [fontWeight]="radioModel?.fontWeight"
      [id]="option?.id"
      [value]="option?.value"
      *ngFor="let option of radioModel?.options"
      >{{ option?.label }}</pg-radio-button
    >
  </pg-radio-group>
</ng-container>
